// AUTO-GENERATED from `ash_medium.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 36330,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5.0
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 48,
        "2": 75,
        "3": 60
      },
      "children": {
        "0": 7,
        "1": 4,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.01
      },
      "gnarliness": {
        "0": 0.03,
        "1": 0.25,
        "2": 0.2,
        "3": 0.09
      },
      "length": {
        "0": 43.47,
        "1": 27.14,
        "2": 9.51,
        "3": 4.6
      },
      "radius": {
        "0": 2,
        "1": 0.63,
        "2": 0.76,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 8,
        "2": 6,
        "3": 4
      },
      "segments": {
        "0": 12,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.23,
        "2": 0.33,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0.09,
        "1": -0.07,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "ash",
      "billboard": "double",
      "angle": 55,
      "count": 16,
      "start": 0,
      "size": 2.67,
      "sizeVariance": 0.72,
      "tint": 16777215,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
